<template>
    <div class="coupon-section">
        <p class="coupon-section--link" @click="showField = !showField" v-html="$t(couponLinkText)"></p>
        <div class="coupon-section--field" v-if="showField">
            <div class="coupon-section--field--main-container">
                <div class="coupon-section--field--container" :class="inputClass">
                    <input
                        :id="`${_uid}-input`"
                        type="text"
                        class="coupon-section--field--input"
                        v-on:keyup.enter.prevent="validateCoupon()"
                        v-model.trim="couponCode">
                    <!-- <div class="coupon-section--field--button" @click="validateCoupon()">
                        <img src="@/assets/images/decoration/arrow-right-black.svg" alt="Apply code button">
                    </div> -->
                </div>
                <button class="coupon-section--field--button" :class="inputClass" @click="validateCoupon()" v-html="couponApplyText">
                </button>
            </div>

            <!-- Validation -->
            <p class="coupon-section--field--message error"
            v-if="isEmpty && isValidated"
            v-text="$t('COUPON_SECTION_FIELD_EMPTY')" />
            <p class="coupon-section--field--message error"
            v-if="!isEmpty && isCouponInvalid && errorHandler.has('coupon')"
            v-text="this.errorHandler.get('coupon')"/>
            <p class="coupon-section--field--message error"
            v-if="!isEmpty && isCouponInvalid && !errorHandler.has('coupon')"
            v-text="$t('COUPON_FIELD_SORRY')"/>

            <!-- success message -->
            <p class="coupon-section--field--message success"
            v-if="!isEmpty && !isCouponInvalid && coupon"
            v-text="coupon.successful_message"/>
        </div>
        <div class="coupon-section--details" v-if="!showField && couponProperties">
            <div class="coupon-section--details--content">
                <img class="coupon-section--details--content--image" src="@/assets/images/pages/checkout/offer-icon.png" alt="offer applied icon">
                <p class="coupon-section--details--content--text">{{couponProperties.successful_message}}<br>{{couponProperties.code}}</p>
            </div>
            <p class="coupon-section--details--content--link" @click="showField=true">{{$t('REGISTER_CHECKOUT_SUMMARY_LINK')}}</p>
        </div>
    </div>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import CouponService from '@/services/coupons/CouponService';
import { formatCouponCode } from '@/helpers/CouponHelpers';

export default {
    name: 'CouponSection',
    props: {
        isValid: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            showField: false,
            couponCode: null,
            coupon: null,
            isValidated: false,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        couponProperties() {
            return this.$store.getters['register/getCouponProperties'];
        },
        couponLinkText() {
            return this.showField ? 'COUPON_SECTION_LINK_HIDE' : 'COUPON_SECTION_LINK_SHOW';
        },
        couponApplyText() {
            return !this.isCouponInvalid && !this.isEmpty ? this.$t('COUPON_SECTION_APPLIED') : this.$t('COUPON_SECTION_APPLY');
        },
        inputClass() {
            if (this.isEmpty && this.isValid === true) {
                return '';
            }
            return !this.isCouponInvalid ? 'success-border' : 'error-border';
        },

        isCouponInvalid() {
            return this.errorHandler.has('coupon') || !this.isValid || !this.coupon;
        },

        isEmpty() {
            return (this.couponCode || '').length === 0;
        },
        deliveryPrice() {
            return this.$globalQueryParams?.dci === '1';
        },
        couponCookie() {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; couponCode=`);

            return parts.length === 2 ? parts.pop().split(';').shift() : null;
        },
    },
    methods: {
        validateCoupon() {
            this.isValidated = true;
            this.coupon = null;

            if (!this.isEmpty) {
                CouponService.getCouponByCouponCode(this.couponCode, this.deliveryPrice)
                    .then(response => {
                        this.errorHandler.reset();
                        this.coupon = response.data.properties;
                        this.$store.commit('account/setSignupCoupon', formatCouponCode(this.coupon.reference));
                        this.$store.commit('register/setFriendCode', formatCouponCode(this.coupon.reference));
                        this.$store.commit('register/setCouponCode', formatCouponCode(this.coupon.code));
                        this.$store.commit('register/setCouponProperties', response.data.properties);
                        localStorage.removeItem('urlCouponCode');

                        if (response.data.properties.coupon_handle) localStorage.setItem('urlCouponCode', response.data.properties.coupon_handle);
                        else if (response.data.properties.product_type.toLowerCase() === 'journey') localStorage.setItem('urlCouponCode', response.data.properties.reference);
                    })
                    .catch(error => {
                        this.errorHandler.setResponse(error.response.data);
                        this.$store.commit('register/setFriendCode', null);
                        this.$store.commit('register/setCouponCode', null);
                        this.$store.commit('register/setCouponProperties', null);
                    });
            } else {
                this.errorHandler.setResponse({ message: 'The given data was empty', errors: { coupon: ['Please enter an offer code'] } });
                this.errorHandler.reset();
                this.$store.commit('register/setFriendCode', null);
                this.$store.commit('register/setCouponCode', null);
                this.$store.commit('register/setCouponProperties', null);
            }
        },
    },
    mounted() {
        this.couponCode = this.$store.getters['register/getCouponCode'];
        this.validateCoupon();
    },
};
</script>

<style lang="scss" scoped>
.coupon-section {
    width: 90%;
    margin: 0 auto;
    padding-left: 11px;
    &--link {
        font-size: 16px;
        font-weight: 300;
        line-height: 24px;
        // text-align: center;
        // text-decoration-line: underline;
        color: #262323;
        margin: 10px auto;
    }
    &--link:hover {
        color: #64A667;
        cursor: pointer;
    }
    &--field {
        display: flex;
        flex-direction: column;
        align-items: center;

        &--input {
            all: unset;
            padding: 8px 20px;
            font-size: 20px;
            font-weight: 200;
            text-transform: uppercase;
            border-radius: 4px;
            background: #ffffff;
        }
        &--message {
            align-self: flex-start;
            font-size: 14px;
            line-height: 14px;
            color: #262323;
            &.error {
                color: #b1473c;
            }
            &.success {
                color: #63A75E;
            }
        }
        &--main-container {
            display: flex;
            width: 100%;
            justify-content: space-between;
        }
        &--container {
            // display: flex;
            border: 1px solid #CECECE;
            width: 60%;
            height: 48px;

            &.success-border {
                border: #63A75E solid 1px;
            }
            &.error-border {
                border: #b1473c solid 1px;
            }
        }
        &--button {
            height: 48px;
            width: 38%;
            border-radius: 4px;
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #000000;
            color: #ffffff;
            // img {
            //     height: 45%;
            //     width: 45%;
            // }
            &.success-border {
                background: #64A667;
            }
            &.error-border {
                background: #000000;
            }
        }
    }
    &--details {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &--content {
            display: flex;
            &--image {
                width: 12px;
                height: 12px;
                margin-right: 10px;
            }
            &--text {
                margin: 0;
                color: #63A75E;
                font-weight: 400;
                font-size: 12px;
                line-height: 15px;
                padding-right: 10px;
            }
            &--link {
                font-size: 12px;
                line-height: 20px;
                color: #63A75E;
                text-decoration: underline;
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .coupon-section--field {
        &--container {
            width: 50%;
            text-align: center;
        }
        &--input {
            width: 80%;
            padding: 7px 5px;
        }
    }
}
</style>
